import api from '@/apis/ca/cAPaymentDetailTaxAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('cAPaymentDetailTax', api);

const state = {
  ...crud.state,
  _config: {
    table: 'ca_payment_detail_tax',
    field: {
      key: 'ref_detail_id',
      // code: 'ref_no'
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
